module.exports = function normalizeHttpUri(input) {
  if (!input) {
    return ''
  }
  return input.trim()
}
